<form class="edit-form" *ngIf="editForm" [formGroup]="editForm">
  <mat-form-field>
    <mat-label>{{ "repository.addressGroups.edit.name.label" | translate }}</mat-label>
    <input type="text" matInput formControlName="name" />
    <mat-error>{{ "repository.addressGroups.edit.name.errorMessage" | translate }}</mat-error>
  </mat-form-field>

  <app-multi-select-list
    formControlName="addresses"
    [allItems]="addresses"
    label="repository.addressGroups.edit.addresses.label"
    errorMsg="repository.addressGroups.edit.addresses.errorMessage"
    [title]="'repository.addressGroups.edit.addresses.title' | translate"
  ></app-multi-select-list>

  <app-multi-select-list
    formControlName="sites"
    [allItems]="sites"
    label="repository.addressGroups.edit.sites.label"
    errorMsg="repository.addressGroups.edit.sites.errorMessage"
    [title]="'repository.addressGroups.edit.sites.title' | translate"
    [required]="false"
    [minItems]="0"
  ></app-multi-select-list>

  <app-multi-select-list
    formControlName="siteGroups"
    [allItems]="siteGroups"
    label="repository.addressGroups.edit.siteGroups.label"
    errorMsg="repository.addressGroups.edit.siteGroups.errorMessage"
    [title]="'repository.addressGroups.edit.siteGroups.title' | translate"
    [required]="false"
    [minItems]="0"
  ></app-multi-select-list>

  <app-validate-and-cancel
    (submitEvent)="endForm($event)"
    [editForm]="editForm"
    [disabling]="editForm.invalid"
  ></app-validate-and-cancel>
</form>
